import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { igolfMappingRequest } from "API/apiConfig";
import { CountryList, DrivingRangeCreate, DrivingRangeDetails, DrivingRangeUpdate, StateList } from "API/apiRequest";


const initialState = {
  status: "idle",
  addRange_info_status: "idle",
  addRange_info_data: {},
  country_list_status: "idle",
  country_list_data :{},
  state_list_status:"idle",
  state_list_data : {},
  range_details_status:"idle",
  range_details_data: {},
  range_update_status:"idle",
  range_update_data:{},
  showCoursesOfRangeDetails: []
};
// range_information
export const range_create = createAsyncThunk(
    "/RangeInfo",
    async ({body,user}) => {
  
      let res =await igolfMappingRequest(DrivingRangeCreate, body, user)
          .then((res) => res)
          .catch((error) => error);
          let resData = {data:res?.data};
        return resData;
    }
  );

  // country list fetch
  export const country_list = createAsyncThunk(
    "/country",
    async ({body,user}) => {
  
      let res =await igolfMappingRequest(CountryList, body, user)
          .then((res) => res)
          .catch((error) => error);
        let resData = {data:res?.data};
        return resData;
    }
  );

// state list fetch
  export const state_list = createAsyncThunk(
    "/state",
    async ({body,user}) => {
  
      let res =await igolfMappingRequest(StateList, body, user)
          .then((res) => res)
          .catch((error) => error);
          let resData = {data:res?.data};
        return resData;
    }
   );

  //  DrivingRangeDetails 
  export const rangeInfo_details = createAsyncThunk(
    "/drivingRangeDetails",
    async ({body,user}) => {
  
      let res =await igolfMappingRequest(DrivingRangeDetails, body, user)
          .then((res) => res)
          .catch((error) => error);
        let resData = {data:res?.data};
        return resData;
    }
  );

  // DrivingRangeUpdate
  export const rangeInfo_update = createAsyncThunk(
    "/drivingRangeUpdate",
    async ({body,user}) => {
  
      let res =await igolfMappingRequest(DrivingRangeUpdate, body, user)
          .then((res) => res)
          .catch((error) => error);
        let resData = {data:res?.data};
        return resData;
    }
  );
  
  export const RangeInfoSlice = createSlice({
    name: "rangeInfo",
    initialState,
    reducers: {
     displayCourseList: (state,action) => {
      state.showCoursesOfRangeDetails =  action?.payload;
    },
    addWithDisplayedCourses:(state,action) => {
      state.showCoursesOfRangeDetails =  [...state.showCoursesOfRangeDetails,action?.payload];
    },
    removeCoursesOfRangeDetails:(state,action) => {
      state.showCoursesOfRangeDetails = action?.payload;
    },
    removeRangeInfoAllDetails: (state,action) => {
      state.addRange_info_data = initialState.addRange_info_data;
      state.country_list_data = initialState.country_list_data
      state.state_list_data = initialState.state_list_data
      state.range_details_data = initialState.range_details_data
      state.range_update_data = initialState.range_update_data
      state.showCoursesOfRangeDetails = initialState.showCoursesOfRangeDetails
    },
    },
    extraReducers: (builder) => {
      builder
        
        .addCase(range_create.pending, (state) => {
          state.addRange_info_status = "loading";
        })
        .addCase(range_create.fulfilled, (state, { payload }) => {
          state.addRange_info_status = "idle";
          state.addRange_info_data =  payload?.data;
        })
        .addCase(range_create.rejected, (state) => {
          state.addRange_info_status = "idle";
        })

        // country list
        .addCase(country_list.pending, (state) => {
          state.country_list_status = "loading";
        })
        .addCase(country_list.fulfilled, (state, { payload }) => {
          state.country_list_status = "idle";
          state.country_list_data =  payload?.data;
        })
        .addCase(country_list.rejected, (state) => {
          state.country_list_status = "idle";
        })

        // state list
        .addCase(state_list.pending, (state) => {
          state.state_list_status = "loading";
        })
        .addCase(state_list.fulfilled, (state, { payload }) => {
          state.state_list_status = "idle";
          state.state_list_data =  payload?.data;
        })
        .addCase(state_list.rejected, (state) => {
          state.state_list_status = "idle";
        })
  
        // Driving Range Details
        .addCase(rangeInfo_details.pending, (state) => {
          state.range_details_status = "loading";
        })
        .addCase(rangeInfo_details.fulfilled, (state, { payload }) => {
          state.range_details_status = "idle";
          state.range_details_data =  payload?.data;
        })
        .addCase(rangeInfo_details.rejected, (state) => {
          state.range_details_status = "idle";
        })

        // drivingRange_update
        .addCase(rangeInfo_update.pending, (state) => {
          state.range_update_status = "loading";
        })
        .addCase(rangeInfo_update.fulfilled, (state ,{ payload }) => {
          state.range_update_status = "idle";
          // state.range_update_data =  payload?.data;
        })
        .addCase(rangeInfo_update.rejected, (state) => {
          state.range_update_status = "idle";
        })

    },
  });
  
  export const { displayCourseList,addWithDisplayedCourses,removeCoursesOfRangeDetails,removeRangeInfoAllDetails } = RangeInfoSlice.actions;
  
  export default RangeInfoSlice.reducer;
  